import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import Button from '@material-ui/core/Button';
import { t } from 'src/lib/language';
import { MouseEvent } from 'react';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { cancelTaxReceiptAction } from 'src/redux/actions/paymentActions';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import LoadingButton from 'src/components/UI/LoadingButton';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';
import Row from 'src/components/UI/Row';
import Form from 'src/components/UI/Form';
import BottomRow from 'src/components/UI/BottomRow';

const CancelTaxReceiptForm = () => {
  const dispatch = useAppDispatch();
  const processing = useSelector(
    (state: Store) => state.formStatus[FORM.cancel_tax_receipt] === FORM_STATUS.processing,
  );
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.payments] || [],
  );

  const handleClose = () => {
    dispatch(closeDialog({ dialog: DIALOGS.cancelTaxReceipt }));
  };

  const handleSubmit = (event: MouseEvent<HTMLElement>) => {
    event.preventDefault();
    dispatch(cancelTaxReceiptAction(selections as number[]));
  };

  return (
    <Form>
      <Row>
        <p>{t(lang, 'menus.cancel_tax_receipt_confirmation')}</p>
      </Row>
      <BottomRow style={{ alignItems: 'top' }}>
        <Button
          variant="contained"
          color="primary"
          style={{ margin: '24px 0px 16px' }}
          onClick={handleClose}>
          {t(lang, 'misc.cancel')}
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          style={{ margin: '24px 0px 16px' }}
          onClick={handleSubmit}
          loading={processing}>
          {t(lang, 'misc.confirm')}
        </LoadingButton>
      </BottomRow>
    </Form>
  );
};

export default CancelTaxReceiptForm;
